import React from 'react';
import { Heading } from '@chakra-ui/react';

const ProfilePage = () => {
  return (
    <div>
      <Heading>Profile</Heading>
    </div>
  );
};

export default ProfilePage;
